module.exports = __webpack_public_path__ + "sflyssofe.277b8e2f14.svg";